import { Component } from '@angular/core';
import { MainLayoutModule } from "./main-layout.module";
import { HeaderComponent } from "../header/header";
import { RouterModule } from "@angular/router";
import { MatSidenavModule } from '@angular/material/sidenav';
import { LoaderComponent } from "../../core/loader/loader.component";

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.html',
  styleUrls: ['./main-layout.scss'],
  imports: [MainLayoutModule, HeaderComponent, RouterModule, MatSidenavModule, LoaderComponent]
})
export class MainLayoutComponent {

  sidenavExpanded: boolean = false;

  constructor() { }

  ngOnInit() {

  }

  onSidenavToggle(isExpanded: boolean): void {
    this.sidenavExpanded = isExpanded;
  }

}
